import React, { useState, useEffect } from 'react';
import { LoginForm, ForgotPasswordForm, NewPasswordForm } from '../features/auth';

const LoginPage = ({ onLoginSuccess }) => {
  const [view, setView] = useState('login');
  const [newPasswordData, setNewPasswordData] = useState({ email: '', session: '' });
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    const expired = sessionStorage.getItem('session_expired');
    if (expired === 'true') {
      setSessionExpired(true);
      sessionStorage.removeItem('session_expired');
      setTimeout(() => setSessionExpired(false), 5000);
    }
  }, []);

  const handleShowForgotPassword = () => setView('forgot-password');
  const handleShowNewPassword = (email, session) => {
    setNewPasswordData({ email, session });
    setView('new-password');
  };
  const handleBackToLogin = () => setView('login');

  return (
    <div className="h-screen max-h-screen flex justify-center items-center relative overflow-hidden">
      {/* Background floating effect */}
      <div 
        className="absolute -top-1/2 -left-1/2 w-[200%] h-[200%] pointer-events-none animate-float"
        style={{
          background: `
            radial-gradient(circle at 20% 50%, rgba(33, 158, 188, 0.12) 0%, transparent 25%),
            radial-gradient(circle at 80% 80%, rgba(77, 196, 224, 0.1) 0%, transparent 25%)
          `
        }}
      />

      {/* Session Expired Notification */}
      {sessionExpired && (
        <div className="fixed top-8 left-1/2 -translate-x-1/2 z-toast animate-slide-down">
          <div className="bg-gradient-to-br from-brand/15 to-brand/10 backdrop-blur-xl border border-brand/30 rounded-xl px-6 py-4 shadow-[0_10px_30px_rgba(33,158,188,0.2),0_0_0_1px_rgba(255,255,255,0.05)] flex items-center gap-3.5 min-w-[380px] max-w-[480px]">
            <span className="text-3xl leading-none flex-shrink-0">⏱️</span>
            <div className="flex-1">
              <strong className="block text-brand-light text-[0.9375rem] font-semibold mb-1">Session Expired</strong>
              <p className="text-secondary text-[0.8125rem] m-0 leading-normal">
                Your session has expired for security reasons. Please login again.
              </p>
            </div>
          </div>
        </div>
      )}

      {view === 'login' && (
        <LoginForm
          onLoginSuccess={onLoginSuccess}
          onShowForgotPassword={handleShowForgotPassword}
          onShowNewPassword={handleShowNewPassword}
        />
      )}
      {view === 'forgot-password' && (
        <ForgotPasswordForm onBack={handleBackToLogin} />
      )}
      {view === 'new-password' && (
        <NewPasswordForm
          email={newPasswordData.email}
          session={newPasswordData.session}
          onSuccess={onLoginSuccess}
        />
      )}
    </div>
  );
};

export default LoginPage;
